import React from "react";
import objectPath from "object-path";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import ToggleButton from "@material-ui/lab/ToggleButton";
import TextField from "@material-ui/core/TextField";
import { FiPlusCircle } from "react-icons/fi";
import Tooltip from "@material-ui/core/Tooltip";

import { addProductSync } from "../../../../Store/Modules/Menu/Actions";
import { setProductDialogState } from "../../../../Store/Modules/Dialogs/Actions";
import { api } from "../../../../Services/Api";
import { Form } from "./style";

export default function AddProductPlusBtn({ categoryId, onClose, ...props }) {
  const dispatch = useDispatch();
  const [formData, setFormData] = React.useState({ categoryId });
  const [anchorEl, setAnchorEl] = React.useState(null);

  function handleInputChange(event) {
    const { name, value } = event.target;
    const updatedFormData = { ...formData };
    objectPath.set(updatedFormData, name, value);
    setFormData(updatedFormData);
  }

  const openEditProduct = (product) => {
    dispatch(setProductDialogState("show", true));
    dispatch(
      setProductDialogState("data", {
        productId: product._id,
        printDescription: product.printDescription,
      })
    );
  };

  function handleAddProduct(event) {
    event.preventDefault();
    api
      .post("/menu/products", formData)
      .then(({ data }) => {
        dispatch(addProductSync(data));
        openEditProduct(data);
        setFormData({ categoryId: data.categoryId });
        handleClose();
      })
      .catch((err) => {
        toast.error("Não foi possível continuar. Por favor atualize a página.");
      })
      .finally(() => {});
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip arrow placement="bottom" title="Adicionar Produto">
        <ToggleButton value="add" {...props} onClick={handleClick}>
          <FiPlusCircle style={{ fontSize: "20px" }} />
        </ToggleButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <div>
          {/* <DialogTitle>Adicionando novo produto</DialogTitle> */}
          <DialogContent>
            <Form onSubmit={handleAddProduct}>
              <TextField
                label="Nome do produto"
                name="printDescription"
                value={formData.printDescription}
                onChange={handleInputChange}
                required
                autoFocus
                variant="outlined"
                size="small"
                autoComplete="off"
              />

              <Button type="submit" variant="contained" color="primary">
                Avançar
              </Button>
            </Form>
          </DialogContent>
          <DialogActions>
            {/* <Button onClick={onRemove} color='secondary' autoFocus>
                Sim
              </Button> */}
            <Button onClick={handleClose} color="default">
              Fechar
            </Button>
          </DialogActions>
        </div>
      </Popover>
    </>
  );
}
